<template>
	<UPage
		:ui="{
			root: 'w-full my-auto px-4 sm:px-6 lg:px-8 py-8 relative isolate overflow-hidden'
		}"
	>
		<div class="max-w-container mx-auto w-full justify-items-center">
			<h2 class="text-4xl sm:text-5xl flex leading-13 p-4 sm:leading-14 pb-8 font-semibold flex-col tracking-tight text-center">
				<span class="text-primary">
					{{ $t('find-address.address') }}
				</span>
				<span class="text-default">
					{{ $t('find-address.not-found') }}
				</span>
			</h2>
			<h3 class="max-w-2xl pb-8 mx-auto text-2xl font-bold text-center">
				{{ t('find-address.subtitle', { address }) }}
				<NuxtLink
					:to="localePath('/get-fiber')"
					class="text-primary hover:underline underline-offset-2 decoration-primary decoration-2"
				>
					{{ t('find-address.go-back') }}
				</NuxtLink>
			</h3>
			<SignupMap
				v-model="pinCoords"
				class="w-full max-w-2xl mx-auto"
				map-id="find-address-map"
				:address="zip"
				:zoom="15"
			/>
			<div class="flex justify-center w-full pt-8">
				<UButton
					:label="t('find-address.button-text')"
					size="xl"
					:ui="{
						base: 'w-full sm:w-72',
						label: 'uppercase font-semibold'
					}"
					@click="submitLocation"
				/>
			</div>
		</div>
	</UPage>
</template>

<script setup lang="ts">
import { useProspectAddress } from '@/composables/useProspectAddress'
import { useI18n } from 'vue-i18n'
import { useRoute } from 'vue-router'

const { t } = useI18n({
	useScope: 'global'
})
const localePath = useLocalePath()

const route = useRoute()

const { getProspectAddressWithCoordinates } = useProspectAddress()

useHead({
	title: t('find-address.meta-title'),
	meta: [
		{
			name: 'description',
			content: t('find-address.meta-description')
		}
	]
})

const zip = computed(() => (route.query?.zip || '80108') as string)
// default to Parker, CO if no zip
const address = computed(() => route.query?.address || 'your address')

const pinCoords = ref()

const submitLocation = async () => {
	await getProspectAddressWithCoordinates(pinCoords.value)
}
</script>
